// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.historyItem {
  width: 100%;
  margin: 0.5rem;
}

.historyItemRow {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0.4rem 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Transaction/Row/history.scss"],"names":[],"mappings":"AACA;EACG,WAAA;EACD,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF","sourcesContent":["\n.historyItem {\n   width: 100%;\n  margin: 0.5rem;\n}\n\n.historyItemRow {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0.4rem 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
